module.exports = __webpack_public_path__ + "static/img/grapefruit_th.1e82562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/grapefruit_th.png
// module id = 3ZWc
// module chunks = 0